import { useMemo } from "react";
import { ListAssetDto } from "../models/assets.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredAssets(assets: ListAssetDto[]) {
	const { query } = useSearch();

	const filteredAssets = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return assets?.filter(asset =>
				(asset.Name && asset.Name.toLowerCase().includes(lowerQuery)) ||
				(asset.AssetTag && asset.AssetTag.toLowerCase().includes(lowerQuery)) ||
				(asset.Description && asset.Description.toLowerCase().includes(lowerQuery)) ||
				(asset.AssetType && asset.AssetType.toLowerCase().includes(lowerQuery)) ||
				(asset.Location?.Title && asset.Location.Title.toLowerCase().includes(lowerQuery)) ||
				(asset.Make && asset.Make.toLowerCase().includes(lowerQuery)) ||
				(asset.Model && asset.Model.toLowerCase().includes(lowerQuery)) ||
				(asset.SerialNumber && asset.SerialNumber.toLowerCase().includes(lowerQuery)) ||
				(asset.Vendors?.some(vendor => vendor.Name && vendor.Name.toLowerCase().includes(lowerQuery))) ||
				// (asset.ParentAsset?.Name && asset.ParentAsset.Name.toLowerCase().includes(lowerQuery)) ||
				(asset.Year != null && asset.Year.toString().includes(lowerQuery)) ||
				(asset.DateOfPurchase != null && asset.DateOfPurchase.toString().toLowerCase().includes(lowerQuery))
			) || [];
		}
		return assets || [];
	}, [query, assets]);

	return { filteredAssets, showNoResults: query && query.length > 0 && filteredAssets.length === 0 };
}
